import {
  faCss3,
  faJava,
  faHtml5,
  faNode,
  faReact,
  faWindows,
  faJs,
  faAccessibleIcon,
  faRaspberryPi,
  faAngular
} from "@fortawesome/free-brands-svg-icons";
import { faTerminal } from "@fortawesome/free-solid-svg-icons";

const skills = () => { return  [
                     {
                       icon: faWindows,
                       name: "C#"
                     },
                     {
                       icon: faNode,
                       name: "Node"
                     },
                     {
                       icon: faJava,
                       name: "Java"
                     },
                     {
                       icon: faJs,
                       name: "JavaScript"
                     },
                     {
                       icon: faReact,
                       name: "React"
                     },
                     {
                       icon: faAngular,
                       name: "Angular"
                     },
                     {
                       icon: faHtml5,
                       name: "HTML"
                     },
                     {
                       icon: faCss3,
                       name: "CSS"
                     },
                     {
                       icon: faTerminal,
                       name: "CLI"
                     },
                     {
                       icon: faRaspberryPi,
                       name: "Raspberry Pi"
                     },
                     {
                       icon: faAccessibleIcon,
                       name: "Accessibility"
                     }
                   ];}
                   export default skills